/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React, { useState } from "react";
import Breadcrumb from "../../../../Basis/Components/Breadcrumb";
import Belegart from "../../Queries/Belegart";
import LadeGutschriftZuMandant from "../../Queries/LadeGutschriftZuMandant";
import LadeRechnungZuMandant from "../../Queries/LadeRechnungZuMandant";
import BelegeUrlsBuilder from "../../Utils/BelegeUrlsBuilder";

export interface MandantBelegBreadcrumbProps {
    belegart: Belegart;
    belegId: string;
}

export default function MandantBelegBreadcrumb(props: MandantBelegBreadcrumbProps) {
    const [caption, setCaption] = useState("");
    if (props.belegart === "RECHNUNG") {
        new LadeRechnungZuMandant({ rechnungId: props.belegId }, (beleg) => {
            setCaption(beleg.nummer)
        });
    } else {
        new LadeGutschriftZuMandant({ gutschriftId: props.belegId }, (beleg) => {
            setCaption(beleg.nummer)
        });
    }

    const url = BelegeUrlsBuilder.getBelegUrl(props.belegart, props.belegId);
    return <Breadcrumb url={url} caption={caption} isMainView />;
}
